
$(document).on('initialized.ocms.ultimate-form', (event, form) => {
  if (OCMS.GlobalVars.Brand === 'mel' && form !== undefined && form !== null && form.id === 'shipping') {
    const CanadaSpecificConfigureShippingMethod = () => {
      let poBox = false;
      const state = form.state();

      const poBoxPattern = /^p+(ostal|ost|\.| )*o*(ffice|\.| )*(box)*/i;
      poBox = poBoxPattern.test(form.address()) || poBox;
      poBox = poBoxPattern.test(form.address2()) || poBox;
      poBox = poBoxPattern.test(form.address3()) || poBox;
      poBox = poBoxPattern.test(form.address4()) || poBox;
      poBox = poBoxPattern.test(form.address5()) || poBox;
      poBox = poBoxPattern.test(form.address6()) || poBox;
      poBox = poBoxPattern.test(form.address7()) || poBox;
      poBox = poBoxPattern.test(form.address8()) || poBox;
      poBox = poBoxPattern.test(form.address9()) || poBox;
      poBox = (state === 'AA' || state === 'AE' || state === 'AR') || poBox;

      const list = $("[data-id='shippingMethodList']");
      list.find('.rdblistShippingMethodStep3 input:radio').attr('disabled', poBox === true);
      list.find(".rdblistShippingMethodStep3[data-title='Standard PO Box / APO / FPO'] input:radio").attr('disabled', poBox === false);
      list.find(".rdblistShippingMethodStep3[data-title='Standard PO Box / APO / FPO'] input:radio").attr('checked', poBox === true);
      list.find(".rdblistShippingMethodStep3[data-title='Boite Postale 9,99$ + taxes'] input:radio").attr('disabled', poBox === false);
      list.find(".rdblistShippingMethodStep3[data-title='Boite Postale 9,99$ + taxes'] input:radio").attr('checked', poBox === true);
      list.find('.rdblistShippingMethodStep3 input:radio').trigger('change');
    };

    $(document).on('change.ocms.ultimate-form', CanadaSpecificConfigureShippingMethod);
  }
});



// WEBPACK FOOTER //
// ./js/countryForm/canada.form.js